export const getErrorMessage = (error: unknown) => {
  return (error as Error)?.message || '';
};
